import React, { type FC } from 'react';
import { Box, type SxProps, useTheme } from '@mui/material';
import { mergeSx } from 'merge-sx';

import { borders } from '@/theme/constants';

export interface CircleIconProps {
  size?: number;
  fill?: string;
  stroke?: string;
  strokeWidth?: number;
  sx?: SxProps;
}

const CircleIcon: FC<CircleIconProps> = ({
  size = 1,
  fill = 'background.default',
  stroke = 'primary.main',
  strokeWidth = 1,
  sx = {}
}) => {
  const { spacing } = useTheme();

  return (
    <Box
      className="CircleIcon-root"
      sx={mergeSx(
        {
          width: spacing(size),
          height: spacing(size),
          borderRadius: spacing(size),
          border: strokeWidth ? `${strokeWidth}px solid` : borders.default,
          borderColor: stroke,
          bgcolor: fill,
          flexShrink: 0,
          m: spacing(size / 2)
        },
        sx
      )}
    />
  );
};

export default CircleIcon;
